import { createStickToBottom } from 'instantsearch-ui-components';
import { useCallback, useEffect, useMemo, useRef, useState } from 'preact/hooks';

var useStickToBottom = createStickToBottom({
    useCallback: useCallback,
    useEffect: useEffect,
    useMemo: useMemo,
    useRef: useRef,
    useState: useState
});

export { useStickToBottom };
